'use client';

import { analyticsEventEmitter } from '@portals/wb-front-analytics-tracker';
import {
  TAnalyticEventParams,
  TPreparedAnalyticEventParams,
} from '@/_analytic/_types';
import { IS_DEV } from '@/_constants/env';

export type TSendAnalyticsEventProps = {
  name: string;
  params?: Partial<TAnalyticEventParams>;
};

export const sendAnalyticsEvent = ({
  name,
  params = {},
}: TSendAnalyticsEventProps) => {
  const preparedParams = Object.entries(
    params,
  ).reduce<TPreparedAnalyticEventParams>((acc, [key, value]) => {
    if (value === null) {
      return acc;
    }

    if (Array.isArray(value)) {
      acc[key] = value.join(', ');
    }

    if (typeof value === 'boolean' || typeof value === 'object') {
      acc[key] = JSON.stringify(value);
    }

    if (typeof value === 'number') {
      acc[key] = value;
    }

    acc[key] = String(value);

    return acc;
  }, {});

  const eventParams = {
    name,
    // общие параметры задаются через setAdditionalParamsGetter при инициализации
    params: preparedParams,
  };

  const isGeDomain = window?.location.hostname.endsWith('.ge');

  if (isGeDomain) {
    return;
  }

  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.log('sendAnalyticsEvent', eventParams);

    return;
  }

  if (!analyticsEventEmitter.getIsInitialized()) {
    console.error('ошибка инициализации аналитики');
  }

  analyticsEventEmitter.sendEvent(eventParams);
};
